export function formatTime(date) {
  // https://gist.github.com/hjst/1326755
  // formats a javascript Date object into a 12h AM/PM time string

  var hour = date.getHours();
  var minute = date.getMinutes();
  var amPM = (hour > 11) ? "pm" : "am";
  if(hour > 12) {
    hour -= 12;
  } else if(hour === 0) {
    hour = "12";
  }
  if(minute < 10) {
    minute = "0" + minute;
  }
  return hour + ":" + minute + amPM;
}

const DAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

const MONTHS = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
];

export const formatDay = date => DAYS[date.getDay()];
export const formatMonth = date => MONTHS[date.getMonth()];



// WEBPACK FOOTER //
// ./src/helpers/date.js